module.exports = __webpack_public_path__ + "static/media/PLAY_MACHINES_2.e488b65d.jpg";